
'use strict';

import $ from 'jquery';

const formData = require('./../modules/formData.js');
import {recaptchaTokenRefresh} from "./recaptcha";

const $subscribeButton = $('.newsletter-form-signup .subscribe');
$subscribeButton.prop('disabled', true);

formData.formdata(
    '.newsletter-form-signup',
    '/ajax/Newsletter/createContact',
    'POST',
    '.form_output',
    require('./../template/customer/form.hbs'),
    function (response, data) {
        $('span.SuccesAanmelding')
            .removeClass('error')
            .text(response.message)
            .show()
            .delay(6000)
            .fadeOut(300);

        recaptchaTokenRefresh();
        $subscribeButton.removeAttr('disabled');
    },
    function (response, data) {
        $('#email-error')
            .text(response.message)
            .show();

        recaptchaTokenRefresh();
        $subscribeButton.removeAttr('disabled');
    });

if (document.querySelector('.newsletter-form-signup')) {
  document.querySelector('.newsletter-form-signup')
    .addEventListener('formValidated', evt => {
      if (evt.detail.valid) {
        $subscribeButton.removeAttr('disabled');
        $('.newsletter-form-signup small.error').remove();
      } else {
        $subscribeButton.prop('disabled', true);
      }
    });

  document.querySelector('.newsletter-form-signup')
    .addEventListener('formSubmitted', () => {
      $subscribeButton.prop('disabled', true);
    });
}
